let socketUrl = '';
let apiServer = '';
let environment = '';
let weixinAppid = '';
let weixinScope = '';
let weixinRedirectUrl = '';
let skipUrl = '';
let apiAppSecret = '';
let ttsUrl = '';
let apiVersion = '';
const socketUrlDev = 'wss://api.zhenheyiguan.com:2348/';
const socketUrlPro = 'wss://api.zhenheyiliao.cn:2348/';
const apiAjaxDev = 'https://api.zhenheyiguan.com';
const apiAjaxPro = 'https://api.zhenheyiliao.cn'; //'https://ics.zhenheyiliao.cn';
const failUrl = 'https://zj.zhenheyiliao.cn';
const apiAppSecretMsgDev = 'JJTDNNZTUJMFJHAHCKLDNYOGTFXYPBVY'; //'WGBBCSJXMLNGZQBLWJIPFZMCXTUVBZBX';
const apiAppSecretMsgPro = 'JJTDNNZTUJMFJHAHCKLDNYOGTFXYPBVY';
const ttsUrlEnv = 'http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&spd=5&text=';
let versionDev = '2.0.0';
let versionPro = '2.0.0';
if (process.env.NODE_ENV == 'development') {
  socketUrl = socketUrlDev;
  apiServer = apiAjaxDev;
  environment = 'development';
  weixinAppid = 'wx93c1ecb0b4689946';
  weixinScope = 'snsapi_login';
  weixinRedirectUrl = 'https:%2F%2Fapi.zhenheyiliao.cn%2Fweixin%2Fdoctor-qr-login-notify';
  skipUrl = 'http://localhost:8080';
  apiAppSecret = apiAppSecretMsgDev;
  ttsUrl = ttsUrlEnv;
  apiVersion = versionDev;
} else { 
  socketUrl = socketUrlPro;
  apiServer = apiAjaxPro;
  environment = 'production';
  weixinAppid = 'wx93c1ecb0b4689946';
  weixinScope = 'snsapi_login';
  weixinRedirectUrl = 'https:%2F%2Fapi.zhenheyiliao.cn%2Fweixin%2Fdoctor-qr-login-notify';
  skipUrl = failUrl;
  apiAppSecret = apiAppSecretMsgPro;
  ttsUrl = ttsUrlEnv;
  apiVersion = versionPro;
}
export default {
  socketUrl,
  apiServer,
  apiAppId: 'DoctorPC',
  apiAppSecret: apiAppSecret,
  apiVersion: apiVersion,
  environment,
  weixinAppid,
  weixinScope,
  weixinRedirectUrl,
  skipUrl,
  ttsUrl,
};


// WEBPACK FOOTER //
// ./src/config/config.js